// extracted by mini-css-extract-plugin
export default {"wrap":"SettingsPage_wrap__20zSb","menuBlock":"SettingsPage_menuBlock__zj-4Z","outletBlock":"SettingsPage_outletBlock__9mTrQ"};